module.exports = __webpack_public_path__ + "img/logo.daf5b6f5.png";